export const defaultStyle = {
  imageBoxWraper: "",
  rangeCardWrpr: "rangeCardWrpr",
  gradTop: "hidden",
  imageBoxWrpr: "test",
  imgWrpr: "mx-auto",
}
export const IMAGE_TEXT_BOX = {
  imageBoxWrpr: " block",
  imgContainer: "imgContainer ",
  imgWrpr:
    "imgWrpr flex scale-100 hover:scale-110 transiImg  rounded-[1rem] lg:w-auto lg:h-auto",
  heading:
    "absolute flex text-white font-Bold text-center leading-[29px] px-20 lg:px-auto lg:w-[275px] bottom-[25px] mx-auto  w-[270px] justify-center z-[1] text-[25px] lg:left-[auto] textShadow",
  contentWrapr: "flex justify-center relative",
  gradTop:
    "absolute lg:bottom-[0px] bottom-[-3px]  w-[22rem] rounded-20 h-[140px] bg-toTopGradient ",
}

export const FIVE_COLUMN_CARDS = {
  imgWrpr:
    "h-min hoverborder overflow-hidden rounded-[30px] px-auto text-sm tracking-wide philyImg text-darkBlue font-medium before:pr-5 w-[195px] grid lg:w-[180px] object-contain",
  contentWrpr: "relative",
  heading:
    "text-xl leading-[20px] absolute flex text-white font-Bold px-auto  bottom-[60px] w-full justify-center z-[1] w-auto tracking-[0]",
  description:
    "text-white absolute text-[15px] px-auto lg:w-auto md:w-[195px] bottom-[40px] text-center  flex justify-center z-[1] leading-[20px]",
  gradTop: "",
  contentWrapr: "contentWrapr flex justify-center w-full pb-12",
  imageBoxWrpr:
    "imageBoxWrpr min-h-auto md:min-w-[180px] min-w-[160px] fivecards",
}
export const IMAGE_TEXT_COLUMN = {
  imgWrpr: "imgWrpr w-[160px] my-0 mx-auto",
  imageBoxWrpr: "imageBoxWrpr lg:w-[250px]",
  contentWrapr: "contentWrapr",
  heading: "flex justify-center font-Bold text-[25px] mb-10",
  description:
    "abtPldehia description text-lightGrey text-center leading-[30px] px-15 text-[18px] lg:w-auto w-3/4 mx-auto tracking-[0]",
}

/*check /Procurement/Vendor-Cyber-Risk-Management for UI */
export const FOUR_IMG_TEXT_CARD = {
  imageBoxWraper: "imageBoxWraper w-full h-full",
  imageBoxWrpr: "imageBoxWrpr w-full h-full flex flex-col",
  imgWrpr: "imgWrpr w-full",
  contentWrapr: "contentWrapr h-full p-[10px] lg:p-20",
  heading:
    "font-['Segoe_UI'] font-bold text-darkGreen text-center leading-[1.2] text-[14px] lg:text-[20px] tracking-normal",
  description:
    "description h-full flex items-center font-MDLZBiteType font-bold text-[14px] lg:text-[25px] text-center tracking-normal leading-[1.2] lg:leading-[30px] text-white",
}

export const FOUR_CARD_IMAGE_TEXT_LAYOUT = {
  imageBoxWraper: "imageBoxWraper w-full h-full",
  imageBoxWrpr:
    "imageBoxWrpr w-full h-full flex flex-col items-center  [&>div]:mb-[16px] ",
  imgWrpr: "imgWrpr h-[200px]",
  contentWrapr: "contentWrapr h-full ",
  heading:
    "font-bold box-border font-Regular lg:text-[21px] mb-[16px] tracking-[0.53px] leading-[31.5px] text-left",
  description:
    "description block font-Regular lg:text-[21px] font-normal md:tracking-[0.53px] md:leading-[31.5px] mb-[16px] text-left h-full flex text-black",
}
export const FOUR_CARD_IMAGE = {
  imageBoxWraper: "imageBoxWraper w-full h-full",
  imageBoxWrpr:
    "imageBoxWrpr w-full h-full flex flex-col items-center  [&>div]:mb-[16px] ",
  imgWrpr: "imgWrpr h-[200px]",
  contentWrapr: "contentWrapr h-full ",
  heading:
    "font-bold box-border font-Regular lg:text-[21px] mb-[16px] tracking-[0.53px] leading-[31.5px] text-left",
  description:
    "description block font-Regular lg:text-[21px] font-normal md:tracking-[0.53px] md:leading-[31.5px] mb-[16px] text-left h-full flex text-black",
}

export const TWO_BY_TWO_CARDS = {
  contentWrpr: "contentWrpr flex w-full text-[33px] font-bold justify-center",
  imageBoxWrpr: "imageBoxWrpr w-2/5 ",
  title: "title text-[50px] font-normal",
  imgWrpr: "imgWrpr",
  description: "description text-lightGrey text-center leading-[30px] px-20",
}

export const THREE_COLUMN_IMAGE_CARDS = {
  imageBoxWraper: "thImagecard pr-0 ", //md:pr-[70px] - removed so that all pages component wil behave same
  imageBoxWrpr: " imageBoxWrpr",
  imgContainer: "mb-[30px]",
  imgWrpr: "mx-auto w-full h-full",
  contentWrpr:
    "flex justify-center h-12 text-2xl relative inset-x-0 bottom-80 text-center w-full ",
  heading:
    "absolute flex text-white font-Bold font-normal text-center leading-[29px] px-auto w-[228px] bottom-[35px] mx-auto justify-center z-[1] text-[25px]",
  contentWrapr:
    "relative flex-col-reverse flex justify-start [&>a]:mb-[8px] [&>a:hover]:underline [&>a:hover]:text-orange [&>a]:after:inline-flex  [&>a]:after:ml-[10px] [&>a]:text-[21px] [&>a]:font-Bold [&>a]:font-bold [&>a]:tracking-[4.2px] [&>a]:text-purple [&>a]:leading-[25.2px] [&>a]:after:content-[''] [&>a]:after:bg-[url('../images/green-arrow.png')] [&>a]:after:w-[20px] [&>a]:after:h-[18px] [&>a]:after:inline-block [&>a]:after:bg-no-repeat [&>a]:after:bg-contain [&>a]:uppercase [&>div>p>a:hover]:text-orange" /* removed absolute &  [&>a]:after:bottom-[10px] for alignment of arrow in safari browser*/,
  gradTop: "",
}
export const THREE_COLUMN_IMAGE_CARDS_WITH_DESC = {
  ...THREE_COLUMN_IMAGE_CARDS,
  contentWrapr:
    "relative flex flex-col-reverse justify-start [&>a]:mb-[8px] [&>a:hover]:underline [&>a:hover]:text-orange [&>a]:after:absolute [&>a]:after:bottom-[10px] [&>a]:after:ml-[10px] [&>a]:text-[21px] [&>a]:font-Bold [&>a]:tracking-[4.2px] [&>a]:text-purple [&>a]:leading-[25.2px] [&>a]:after:content-[''] [&>a]:after:bg-[url('../images/green-arrow.png')] [&>a]:after:w-[20px] [&>a]:after:h-[18px] [&>a]:after:inline-block [&>a]:after:bg-no-repeat [&>a]:after:bg-contain",
  linkWrpr: "w-full",
  description: "w-full text-21 text-black  tracking-[0.53px] font-Regular",
}

export const TAB_STYLES = {
  imageBoxWrpr: "imageBoxWrpr w-2/5 ",
  imgContainer: "imgContainer flex p-15 w-[150px]",
  imgWrpr: " imgWrpr w-[150px] [h-150px]",
  heading: "text-[17px] ",
}

export const TWO_COLUMN_IMAGE_CARDS = {
  imgContainer: "imgContainer w-full",
  imageBoxWraper: "imageBoxWraper",
  imageBoxWrpr: "imageBoxWrpr ",
  imgWrpr: "mx-auto w-full h-full mb-[15px] lg:mb-30",
  contentWrpr:
    "flex justify-center h-12 text-2xl relative inset-x-0 bottom-80 text-center w-full ",
  heading:
    "heading font-Regular !font-[700] text-[14px] md:text-[21px] text-purple [&>p:hover]:underline [&>p:hover]:text-orange [&>p]:tracking-[2.8px] uppercase",
  contentWrapr:
    " ArrowLeft contentWrpr relative font-Regular !font-[700] text-[14px] md:text-[21px] pointer-events-auto text-purple [&>p:hover]:underline [&>p:hover]:text-orange [&>p]:tracking-[4.2px] uppercase tracking-[2.8px] leading-[1.2] mt-0 box-border cursor-pointer text-normal max-md:[&>a]:pb-10", //mb-[35px]
  gradTop: "gradTop",
  linkWrpr: "linkWrpr",
}
export const IMAGES_INLINE = {
  ...defaultStyle,
  imgWrpr: "max-w-[75px]",
  imageBoxWrpr: "imageBoxWrpr w-full p-[6px] ",
}

export const IMAGES_INLINE_SMALL = {
  ...defaultStyle,
  imgWrpr: "max-w-[50px]",
  imageBoxWrpr: "imageBoxWrpr w-full p-[6px] ",
}

export const IMAGES_INLINE_BIG = {
  ...defaultStyle,
  imgWrpr: "max-w-[100px]",
  imageBoxWrpr: "imageBoxWrpr w-full p-[6px] ",
}

export const IMAGES_INLINE_LARGE = {
  ...defaultStyle,
  imgWrpr: "max-w-[125px]",
  imageBoxWrpr: "imageBoxWrpr w-full p-[6px] ",
}

export const TWO_COLUMN_IMAGE_CARDS_WITH_TEXT = {
  ...TWO_COLUMN_IMAGE_CARDS,
  heading:
    "heading font-Regular !font-[700] text-[14px] md:text-[21px] text-purple [&>p:hover]:underline [&>p:hover]:text-orange [&>p]:tracking-[4.2px] uppercase mb-[8px] md:mb-[50px]",
  contentWrapr:
    " ArrowLeft contentWrpr relative flex flex-col font-Regular !font-[700] text-[14px] md:text-[21px] text-purple [&>p:hover]:underline [&>p:hover]:text-orange [&>p]:tracking-[4.2px] uppercase tracking-[2.8px] leading-[1.2] mt-0 box-border cursor-pointer text-normal mb-[8px]",
  description:
    "description [&>p>a]:capitalize md:text-[21px] leading-[21px] md:px-[30px] lg:px-0 lowercase [&>p]:tracking-[0.53px] [&>p]:md:leading-[1.5] font-Regular font-normal text-[14px] [&>p]:text-[#000] [&>p>a]:text-[#4f2170] [&>p>a]:font-bold [&>p>a]:tracking-[0.53px] [&>p>a]:md:tracking-[2.2px] lowercase",
}
export const PACKAGING_PLASTICS_IMAGE_CARD = {
  imageBoxWraper: "thImagecard md:pr-[70px]",
  imageBoxWrpr: " imageBoxWrpr",
  imgContainer: "mb-[30px]",
  imgWrpr:
    "mx-auto  rounded-[20px] w-full h-full  hover:scale-[1.05] transition-all duration-1000",
  contentWrpr:
    "flex justify-center h-12 text-2xl relative inset-x-0 bottom-80 text-center w-full ",
  heading:
    "absolute flex text-white font-Bold font-normal text-center leading-[29px] px-auto w-[228px] bottom-[35px] mx-auto justify-center z-[1] text-[25px]",
  contentWrapr:
    "relative flex justify-start [&>a]:mb-[8px] [&>a:hover]:underline [&>a:hover]:text-orange [&>a]:after:absolute [&>a]:after:bottom-[10px] [&>a]:after:ml-[10px] [&>a]:text-[14px] md:[&>a]:!text-[21px] [&>a]:font-Bold md:[&>a]:!tracking-[4.2px] [&>a]:tracking-[2.8px] [&>a]:text-purple md:[&>a]:!leading-[25.2px] [&>a]:leading-[16.8px] [&>a]:after:content-[''] [&>a]:after:bg-[url('../images/green-arrow.png')] md:[&>a]:after:w-[20px] [&>a]:after:w-[12px] md:[&>a]:after:h-[18px] [&>a]:after:h-[12px] [&>a]:after:inline-block [&>a]:after:bg-no-repeat [&>a]:after:bg-contain",
  gradTop: "",
}

export const THREE_COLUMN_IMAGE_CARDS_WITH_BUTTON = {
  ...THREE_COLUMN_IMAGE_CARDS,
  contentWrapr: "relative flex flex-wrap px-[20px] lg:px-0",
  heading:
    "heading w-full font-MDLZBiteType text-center lg:text-left text-purple text-[14px] md:text-[28px] tracking-normal leading-normal mb-[8px]",
  linkWrpr:
    " text-[21px] inline-block button md:text-[21px] font-Regular font-bold text-white bg-purple tracking-[0.53px] leading-[21px] py-[20px] px-[54px] md:px-[60px] mx-auto uppercase rounded-[40px] text-center hover:bg-lightpurple hover:border-lightpurple border-[2px] border-purple md:w-full lg:w-auto w-90% cursor-pointer box-border ",
  description:
    "description  pb-[35px] [&>p>a]:text-purple [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:underline [&>p>a]:tracking-[2.2px] [&>p>a:hover]:tracking-[2.2px] [&>p>strong>a]:tracking-[2.2px] [&>p>strong>a:hover]:tracking-[2.2px] [&>p>strong>a]:text-purple [&>p>strong>a:hover]:text-orange [&>p>strong:hover>a:hover]:underline",
  imgWrpr: "mx-auto w-full h-full cursor-pointer",
}

export const THREE_COLUMN_IMAGE_CARDS_WITH_BUTTON_LEFT = {
  imageBoxWraper: "",
  rangeCardWrpr: "",
  gradTop: "",
  imageBoxWrpr: "",
  imgContainer: "text-center",
  imgWrpr: "mx-auto mb-24",
  heading: "font-BwSurco text-[26px] leading-[31.2px] text-black font-bold",
  description: "font-BwSurco text-[20px] leading-[24px] text-black"
}

export const ABOUT_US_CARD_DETAIL = {
  imageBoxWraper: "",
  rangeCardWrpr: "",
  gradTop: "",
  imageBoxWrpr: "",
  imgWrpr: "mx-auto mb-24",
  heading: "card-detail-content font-BwSurco text-[26px] leading-[31.2px] text-black font-bold mb-16 text-center",
  description: "font-BwSurco text-[20px] leading-[24px] text-black"
}

export const CAROUSEL_SLIDER_IMG_CARD = {
  imageBoxWraper: "",
  imageBoxWrpr: "flex flex-col-reverse lg:flex-row-reverse justify-between",
  imgContainer: "w-full lg:w-[32.5%]",
  contentWrapr: "w-full lg:w-[61.5%] mb-[20px] lg:mb-0",
  rangeCardWrpr: "",
  gradTop: "",
  imgWrpr: "mx-auto",
  heading: "font-MDLZBiteType text-[48px] leading-[57.6px] text-purple mb-[32px] [&>p]:after:content-[''] [&>p]:after:h-[10px] [&>p]:after:w-[48px] [&>p]:after:bg-[#CA9953] [&>p]:after:block [&>p]:after:mt-16",
  description: "font-BwSurco text-[20px] leading-[26px] lg:text-[26px] lg:leading-[31.2px] tracking-normal text-black flex flex-col gap-[16px]"
}

export const COMMUNITY_IMG_CARD = {
  contentWrapr:"contentWrapr",
  heading:"heading bg-[#FFD8AA] text-[#4F2170] p-[20px] lg:p-[15px] xl:p-[20px] text-[26px] leading-[31.2px] font-BwSurco rounded-[100px] font-bold mb-[24px] min-h-[113px] flex items-center hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out [&>p]:pl-[16px]",
  description:"description text-white text-[20px] leading-[24px] font-[400] font-BwSurco",
  imgWrpr: "mx-auto",
}
export const PILLARS_CARDS = {
  contentWrapr:"contentWrapr",
  heading:"heading bg-[#FFD8AA] text-[#4F2170] p-[20px] lg:p-[15px] xl:p-[20px] text-[26px] leading-[31.2px] font-BwSurco rounded-[100px] font-bold mb-[24px] min-h-[113px] flex items-center hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out [&>p]:pl-[16px]",
  description:"description text-black text-[20px] leading-[24px] font-[400] font-BwSurco",
  imgWrpr: "mx-auto",
}
export const MULTI_SECTION_CAROUSEL_SUB_SLIDER_ONE = {
  imageBoxWrpr: " block",
  imgContainer: "imgContainer ",
  imgWrpr:
    "imgWrpr",
  heading:
    "heading font-Bold text-center",
  description: "text-20 leading-[24px]",
  contentWrapr: "contentWrapr text-[20px] leading-[29px]",
  gradTop:
    "gradTop",
}